import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'
Vue.use(Router)

export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },

  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/part'
    // children: [{
    //   path: 'dashboard',
    //   name: 'Dashboard',
    //   component: () => import('@/views/home/index'),
    //   meta: { title: '首页', icon: 'dashboard' }
    // }]
  },
  {
    path: '/part',
    component: Layout,
    redirect: '/index',
    name: '兼职管理',
    meta: { title: '兼职管理', icon: '' },
    children: [
      {
        path: '/index',
        name: 'part',
        component: () => import('@/views/part/index'),
        meta: { title: '兼职管理', icon: '' }
      },
      {
        path: 'details',
        name: 'index',
        component: () => import('@/views/part/details')
      }
    ]
  },

  {
    path: '/business',
    component: Layout,
    redirect: '/business/index',
    name: '商户岗位审核',
    meta: { title: '商户岗位审核', icon: '' },
    children: [
      {
        path: 'index',
        name: 'user',
        component: () => import('@/views/business/index'),
        meta: { title: '商户岗位审核', icon: '' }
      },
      {
        path: 'details',
        name: 'index',
        component: () => import('@/views/business/details')
      }
    ]
  },
  // {
  // path: '/parts',
  // component: Layout,
  // children: [
  // {
  // path: 'edit',
  // name: 'edit',
  // component: () => import('@/views/part/edit'),
  // meta: { title: '新增项目', icon: 'form' }
  // }
  // ]
  // },
  {
    path: '/getTable',
    component: Layout,
    children: [
      {
        path: 'chuandan',
        name: '照片审核',
        component: () => import('@/views/chuandan/chuandan'),
        meta: { title: '照片审核', icon: '' }
      }
    ]
  },
  {
    path: '/user',
    component: Layout, // 这个是决定这个路由地址显示那个vue组件，也就是.vue文件
    redirect: '/index',
    name: '用户列表',
    meta: { title: '用户列表', icon: '' },
    children: [
      {
        path: 'index',
        name: 'user',
        component: () => import('@/views/user/index'),
        meta: { title: '用户列表', icon: '' }
      },
      {
        path: 'detail',
        name: 'index',
        component: () => import('@/views/user/detail')
      }
    ]
  },
  {
    path: '/businessUser',
    component: Layout,
    redirect: '/businessUser/index',
    name: '商户列表',
    meta: { title: '商户列表', icon: '' },
    children: [
      {
        path: 'index',
        name: 'user',
        component: () => import('@/views/businessUser/index'),
        meta: { title: '商户列表', icon: '' }
      },
      {
        path: 'details',
        name: 'detail',
        component: () => import('@/views/businessUser/details')
      }
    ]
  },
  {
    path: '/payoff',
    component: Layout,
    children: [
      {
        path: 'payoff',
        name: '薪资发放记录',
        component: () => import('@/views/payoff/index'),
        meta: { title: '工资发放记录', icon: '' }
      }
    ]
  },
  {
    path: '/cashs',
    component: Layout,
    children: [
      {
        path: 'cashs',
        name: '提现申请',
        component: () => import('@/views/cashs/index'),
        meta: { title: '提现申请', icon: '' }
      }
    ]
  },
  {
    path: '/notice',
    component: Layout,
    name: '公告管理',
    meta: { title: '公告管理', icon: '' },
    children: [
      {
        path: 'gztxjl',
        name: 'gztxjl',
        component: () => import('@/views/notice/noticelist'),
        meta: { title: '公告列表', icon: '' }
      }
    ]
  },
  {
    path: '/yzm',
    component: Layout,
    children: [
      {
        path: 'index',
        name: 'yzm',
        component: () => import('@/views/yzm/yzm'),
        meta: { title: '验证码列表', icon: '' }
      }
    ]
  },
  {
    path: '/system',
    component: Layout,
    redirect: '/index',
    name: '系统管理',
    meta: { title: '系统管理', icon: '' },
    children: [
      {
        path: 'admin',
        name: 'system',
        component: () => import('@/views/system/admin'),
        meta: { title: '系统用户管理', icon: '' }
      },
      {
        path: 'updatepwd',
        name: 'system',
        component: () => import('@/views/system/updatepwd'),
        meta: { title: '修改密码', icon: '' }
      }
    ]
  },
  {
    path: '/community',
    component: Layout,
    name: '社群管理',
    meta: { title: '社群管理', icon: '' },
    children: [
      {
        path: 'list',
        name: 'list',
        component: () => import('@/views/community/list'),
        meta: { title: '社群管理', icon: '' }
      }
    ]
  },
  {
    path: '/parts',
    component: Layout,
    children: [
      {
        path: 'edit',
        name: 'edit',
        component: () => import('@/views/part/edit'),
        meta: { title: '新增项目', icon: 'el-icon-document-add' }
      }
    ]
  },

  
  {
    path: '/shangji',
    component: Layout,
    name: '商机管理',
    meta: { title: '商机管理', icon: '' },
    children: [
      {
        path: 'index',
        name: 'shangji',
        component: () => import('@/views/shangji/index'),
        meta: { title: '商机管理', icon: '' }
      },
      {
        path: '/shangjiClue',
        name: 'shangjiClue',
        component: () => import('@/views/shangjiClue/index'),
        meta: { title: '商机线索', icon: '' },
        hidden: true
      },
      {
        path: '/shangjiClueWallet',
        name: 'shangjiClueWallet',
        component: () => import('@/views/shangjiClue/wallet'),
        meta: { title: '线索钱包', icon: '' },
        hidden: true
      }
    ]
  },
  
  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () =>
  new Router({
    mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  })

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
